<template>
    <v-card>
        <v-toolbar flat>
            <v-btn @click="$emit('closeDialog')" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
                Add Student To This Group
            </v-toolbar-title>
            <v-spacer>
            </v-spacer>
            <v-btn @click="addToGroup" v-if="selected!=null" color="primary">
                Add
            </v-btn>
        </v-toolbar>
        <v-card-text>

            <v-data-table
                    single-select
                    :loading="loading"
                    :page.sync="page"
                    :items="items"
                    :headers="headers"
                    hide-default-footer
                    show-select
                    @item-selected="studentSelected"
            >
                <template v-slot:item.name="{ item }">
                    <v-btn text color="primary">
                        <!--          <router-link-->
                        <!--            class="profile-link"-->
                        <!--            active-class="active"-->
                        <!--            :exact="true"-->
                        <!--            :to="{name: 'StudentProfile'}"-->
                        <!--          >{{item.name}}</router-link>-->
                        {{item.user.first_name}} {{item.user.last_name}}
                    </v-btn>
                </template>
                <template v-slot:item.father_name="{ item }">
                    {{item.guardian.first_name}} {{item.guardian.first_name}}
                </template>
                <template v-slot:item.phone_number="{ item }">
                    {{item.guardian.contact_number}}
                </template>
                <template v-slot:item.class_name="{ item }">
                    {{item.class_name}}
                </template>
                <template v-slot:item.created_at="{ item }">
                    {{item.created_at}}
                </template>

            </v-data-table>
            <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Students
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
                <v-spacer></v-spacer>
                <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import DataTableMixin from "../../mixins/dataTable";

    export default {
        name: "AddToGroupTable",
        mixins: [
            DataTableMixin
        ],
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                selected: null,
                currentRow: 0,
                loading: true,
                discount_dialog: false,
                tutor_assign_dialog: false,
                page: 1,
                pageCount: 3,
                itemsPerPage: 10,
                headers: [
                    {text: "SRNO", sortable: true, value: "id"},
                    {text: "Student Id", sortable: true, value: "id"},
                    {text: "Name", value: "name", sortable: true},
                    {text: "Father Name", value: "father_name", sortable: true},
                    {text: "Phone Number", value: "phone_number", sortable: true},
                    {text: "Class", value: "class_name", sortable: true},
                    {text: "Enquiry At", value: "created_at", sortable: true},
                ],
            };
        },
        methods: {
            studentSelected(item) {
                if (item.value) {
                    this.selected = item.item
                } else {
                    this.selected = null
                }
            },
            addToGroup() {
                if (this.selected !== null) {
                    axios.get(apiRoutes.students.addToGroup + this.selected.user_id + "/" + this.id).then(response => {
                        if (response.data.success) {
                            this.getItems()
                            this.selected=null
                            this.$emit("studentAdded")
                        }
                    })
                }
            },
            getItems() {
                let params = {
                    ...this.formQueryParams(),
                    not_in_group: this.id
                }
                axios.get(apiRoutes.students.url, {
                    params: params
                }).then(response => {
                    this.formalizeTable(response.data)
                    this.loading = false
                })
            },
            addDiscount(item) {
                this.currentRow = item.user_id
                this.discount_dialog = !this.discount_dialog
            },
            cancelDiscount() {
                this.currentRow = 0
                this.discount_dialog = !this.discount_dialog
            }
        },
        mounted() {
            this.getItems()
        }
    }
</script>

<style scoped>

</style>